export default __webpack_public_path__ + "static/media/header-img.d5d14495.png";